export default __webpack_public_path__ + "static/curico-bca9ec8cf0a2630041b6e6c575578d5c.png";